import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EditorInternalStatus } from '../documents/editor-internal-status';
import { StoreTemplateStatus } from '@pt/pt-models';

@Component({
  selector: 'pt-user-checked-dialog',
  template: `
    <div class='modal-header'>
      <h4 class='modal-title'>
        {{ doc.name }}
      </h4>
    </div>

    <div class='modal-body'>
      {{ showValidDocument ? ('MESSAGE.ALIGNED_DOCUMENT' | translate) : ('MESSAGE.NOT_ALIGNED_DOCUMENT' | translate) }}
    </div>

    <div class='modal-footer' *ngIf='!showValidDocument'>
      <button type='button'
              class='btn btn-primary btn-sm'
              (click)='reopen(); $event.stopPropagation()'>
        {{ 'BUTTON.REOPEN_PROCESS' | translate }}
      </button>

      <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
              (click)='close(); $event.stopPropagation()'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </div>

    <div class='modal-footer' *ngIf='showValidDocument'>
      <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
              (click)='confirm(); $event.stopPropagation()'>
        {{ 'BUTTON.OK' | translate }}
      </button>
    </div>
  `,
  styles: [``]
})
export class UserCheckedDialogComponent implements OnInit {
  @Input() document: any;
  @Input() state: StoreTemplateStatus;

  doc: any;
  completedValue: number;
  showValidDocument: boolean;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.doc = this.document;
    this.completedValue = EditorInternalStatus.calculatePercentageOfCompletion(this.state.totalWidget, this.state.validWidgetId?.length);
    /**
     * Se la % del documento originaria era 100% e adesso è ancora 100%,
     * nella modale aperta mostrare un messaggio per avvisare l'utente
     * che il documento è allineato con le nuove modifiche.
     * Chiamare l'API  POST "/{id}/user-checked" che rimette il flag userCheck a false nel BE.
     */

    /**
     * Altrimenti l'utente deve essere avvisato che il documento non è più completato
     * ed è necessario riaprire il documento.
     * L'utente potrà fare due cose:
     * cliccare su riapri nella modale ( API /reopen)
     * altrimenti annulla che riporta l'utente nella pagina dei documenti senza fare nulla.
     */

    this.showValidDocument = this.doc.completed === 100 && this.doc.completed === this.completedValue;
  }

  confirm() {
    this.activeModal.close('CONFIRM');
  }

  close() {
    this.activeModal.close('CLOSE');
  }

  reopen() {
    this.activeModal.close('REOPEN');
  }
}
